import { useEffect } from 'react' 
import { useLocation } from 'react-router-dom'
import { urlSearchParams } from '@/util/urlSearchParams'
import { useDispatch } from 'react-redux'
import { updateCurrentUserSettings } from '@/store/account'
import { setActiveLanguage } from '@/store/app'

const RouteController = props => {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    storeLang()
  }, [location])

  /** Keep Redux language in sync with `/pt-br/...` URLs (same as server-rendered locale). */
  useEffect(() => {
    const { pathname } = location
    if (pathname === '/pt-br' || pathname.startsWith('/pt-br/')) {
      dispatch(setActiveLanguage('pt-br'))
    }
  }, [location.pathname, dispatch])

  const storeLang = () => {
    const query = new urlSearchParams(location.search)
    if (query.has('lg')) {
      dispatch(updateCurrentUserSettings({ language: query.get('lg') }))
    }
  }

  return props.children
}

export default RouteController
